import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Wallet.css';
import {  useProfile } from '../context/ProfileContext';
function Wallet({ balance }) {
  const navigate = useNavigate();
  const { profile } = useProfile();

  const handleDeposit = () => {
    navigate('/deposit'); // Navigate to the deposit page
  };
  

  const handleWithdraw = () => {
    navigate('/withdraw'); // Navigate to the withdraw page
  };

  return (
    <div className="wallet-container">
      <div className="wallet-header">
        <button className="back-button" onClick={() => navigate('/')}>← </button>
        <h1>My Wallet</h1>
      </div>
      
      <div className="balance-section">
        <h2>Current Balance</h2>
        <div className="balance-amount">₹{profile.walletBalance}</div>
      </div>

      <div className="action-buttons">
        <button className="deposit-button" onClick={handleDeposit}>
          Deposit
        </button>
        <button className="withdraw-button" onClick={handleWithdraw}>
          Withdraw
        </button>
      </div>
    </div>
  );
}

export default Wallet; 